//FirebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, Analytics } from "firebase/analytics";
import { marketingAllowed } from './utils/supportSecurity';

const firebaseConfig = {
  apiKey: "AIzaSyD-wi-Nftqkh826GUIaeP8SPz3kO9GQ1lo",
  authDomain: "askpoeai.firebaseapp.com",
  projectId: "askpoeai",
  storageBucket: "askpoeai.appspot.com",
  messagingSenderId: "165454637276",
  appId: "1:165454637276:web:4f9aafa486c16ca8f4ec19",
  measurementId: "G-LRZ3113586"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// analytics should only run in browser
export let analytics: Analytics | null = null;
if (marketingAllowed()) {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    // Analytics support must never prevent Auth or the rest of the application from starting.
    console.warn('Firebase Analytics initialization is unavailable.', error);
  }
}

export { app, db };
